import React from 'react';
import { Link } from '../../../constants/ContactInfo';
import AriaLink from '../../AriaLink/AriaLink';
import './ContactInfo.scss';

interface Props {
  header: string;
  content?: string[];
  links?: Link[];
}

const ContactInfo: React.FC<Props> = ({ header, content, links }: Props) => {
  return (
    <div className="contact tablet:grid-col-fill">
      <strong>{header}</strong>
      {content?.map((text) => (
        <p key={text}>{text}</p>
      ))}
      {links?.map((link) => (
        <p key={link.href}>
          <AriaLink link={link.href} linkType={link.type} customLinkText={link.text} customTitle={link.customTitle} />
        </p>
      ))}
    </div>
  );
};

ContactInfo.defaultProps = { content: [], links: [] };

export default ContactInfo;
